import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
// import { useEffect } from 'react'
import { useEffect } from 'react';
import { pdfjs } from 'react-pdf';
import { useDispatch } from 'react-redux';
import HandlePackageJsonVersion from './components/general/HandlePackageJsonVersion';
import MfSweetAlert from './components/general/MfSweetAlert';
import useEE from './components/hooks/easterEgg';
import useFeaturebase from './hooks/useFeaturebase';
import { initializeAuth } from './redux/storeConfig/slices/slice.auth';
import MFRouter from './router/MFRouter';
import 'react-toastify/dist/ReactToastify.css';
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
HandlePackageJsonVersion();
const App = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        initializeAuth()(dispatch);
    }, [dispatch]);
    useEE();
    // const { handleAdminValidation, checkStorageToken } = useSession()
    useFeaturebase();
    // useEffect(() => {
    //   checkStorageToken()
    // }, [checkStorageToken])
    // useEffect(() => {
    //   handleAdminValidation()
    // }, [handleAdminValidation])
    return (_jsxs(Box, { h: "100%", children: [_jsx(MfSweetAlert, {}), _jsx(MFRouter, {})] }));
};
export default App;
